import React, { Component } from 'react';

class ListTable extends Component {
    static defaultProps = {list:[], classes:[]};
    
    render() {
        let style = {width:"100%"};

        if (this.props.fixed) {
            style["tableLayout"] = "fixed";
        }
        
        return (
            <table className="ListTable" style={style}>
              <tbody>
                {this.props.list.map(function(dataList, i) {
                    let tds = dataList.map(function(data, j) {
                        let className = "";

                        if(this.props.classes[j]) {
                            className = this.props.classes[j];
                        }
                        
                        return <td key={"lt-ij-" + i + "-" + j} className={className}>{data}</td>;
                    }, this);
                    
                    return <tr key={"lt-i-" + i}>{tds}</tr>;
                }, this)}
              </tbody>
            </table>
        );
    }
}

export default ListTable;
